import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { Grid, Paper, Typography, CircularProgress } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import starIcon from 'images/svg/star-icon.svg'
import { TITLES } from '../../../constants'
import { isUserPremium } from '../../../utils'

const styles = theme => ({
  root: {
    flexGrow: 1,
    overflowX: 'hidden',
  },
  paper: {
    padding: '8% 8% 10px',
    width: 500,
    boxShadow: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingBottom: '20px',
    },
  },
  component: {
    width: '100%',
  },
  title: {
    paddingBottom: '5%',
  },
  closeIcon: {
    textAlign: 'right',
    cursor: 'pointer',
  },
  heading: {
    [theme.breakpoints.up('md')]: {
      fontSize: '27px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '21px',
    },
  },
  progress: {
    color: '#00bcb5',
  },
  profileIcon: {
    width: '18px',
    height: '18px',
    margin: '0 0 0 8px',
  },
  premiumCaption: {
    fontSize: '14px',
    fontWeight: '500',
    textTransform: 'uppercase',
    lineHeight: '100%',
    color: '#838383',
  },
})

const InvestorMenuContentPanel = props => (
  <div className={props.classes.root}>
    <Paper className={props.classes.paper}>
      <Grid container>
        <Grid container className={props.classes.title}>
          <Grid item xs={11}>
            <Typography gutterBottom variant="title" className={props.classes.heading}>
              {props.title}
              {props.title === TITLES.PROFILE && isUserPremium(props.user) && <img alt="star" className={props.classes.profileIcon} src={starIcon} />}
            </Typography>
            {props.title === TITLES.PROFILE && isUserPremium(props.user) && <div className={props.classes.premiumCaption}>Premium Member</div>}
          </Grid>
          <Grid item xs={1} className={props.classes.closeIcon}>
            <Close onClick={props.handleClose} />
          </Grid>
        </Grid>
        {!props.isLoading ? (
          <Grid item className={props.classes.component}>
            {props.children}
          </Grid>
        ) : (
          <CircularProgress className={props.classes.progress} />
        )}
      </Grid>
    </Paper>
  </div>
)

InvestorMenuContentPanel.propTypes = {
  classes: PropTypes.object,
}

export default withStyles(styles)(InvestorMenuContentPanel)



// WEBPACK FOOTER //
// ./src/features/investorDashboard/components/InvestorMenuContentPanel.js